<template>
    <nav-tabs :exact="false" :tabs="[
        { label: 'Motivos de recusa', route: 'reasons' },
        { label: 'Termos jurídicos', route: 'legal-terms' },
        { label: 'Ativações Gerais', route: 'platform-settings' },
    ]" />
    <router-view></router-view>
</template>

<script>
import NavTabs from "../../components/layouts/NavTabs.vue";
export default {
    components: { NavTabs },

    mounted() {

    }
}
</script>
